angular.module('impactx.rfx').controller('RFXShareDialogCtrl', [
    '$mdDialog',
    '$scope',
    'themeFactory',
    'ToastService',
    'TranslationService',
    'dataGen',
    '$copyToClipboard',
    RFXShareDialogCtrl]);

function RFXShareDialogCtrl($mdDialog, $scope, themeFactory, ToastService, TranslationService, dataGen, $copyToClipboard) {
    var self = this;
    $scope.abortLabel = TranslationService.get("abort");
    $scope.acceptLabel = TranslationService.get("send");
    $scope.hasMail = false;

    $scope.mailList = [{label: "1.", value: ""}];

    this.copyCodeToClipboard = function () {
        var code = impactX.isDefined(self, 'offerCode.value');
        if (code) {
            $copyToClipboard.copy(code).then(function () {
                ToastService.openStandardToast(self.copySuccessLabel);
            });
        }
    };

    this.changeMail = function (index, value) {
        if (index === $scope.mailList.length - 1) {
            $scope.mailList.push({label: (index + 2) + ".", value: ""});
        }
        $scope.hasMail = false;
        for (var i = 0; i < $scope.mailList.length; i++) {
            if ($scope.mailList[i].value && $scope.mailList[i].value.length > 0){
                $scope.hasMail = true;
                break;
            }
        }
    };

    this.cancel = function () {
        $mdDialog.cancel();
    };

    this.answer = function () {
        dataGen.postAsForm($scope, {rfqsId: self.rfqsId, mailList: $scope.mailList}, "/rfx/share").then(function (data) {
            $mdDialog.hide();
            ToastService.openStandardToast(data.trns.success);
        });
    };

    this.hasNoMail = function () {
        return !$scope.hasMail;
    }
}